import { removeUndefined } from '../../../../helpers';
import { sessionStorage } from '../../../../helpers/storage';
import { DADATA_FORM_FIELDS_MAP, PROFILE_PEOPLE_FIELDS_MAP, SESSION_STORAGE_FORM_KEY } from '../../../../constants';

export const getNewData = (prevData: FE.FormData, currentData: FE.FormData) => {
    const allFields = new Set([...Object.keys(prevData), ...Object.keys(currentData)]);
    const profileFields = Object.keys(PROFILE_PEOPLE_FIELDS_MAP);
    const dadataFields = Object.keys(DADATA_FORM_FIELDS_MAP);
    return removeUndefined(
        Array.from(allFields.values()).reduce((prev, field) => {
            if (
                profileFields.includes(field) &&
                !dadataFields.includes(field) &&
                String(prevData[field]) !== String(currentData[field])
            ) {
                return Object.assign(prev, { [field]: currentData[field] });
            }
            return prev;
        }, {} as FE.FormData),
        [''],
        true,
    );
};

const sessionFormData = {
    modifiedButNotSaved: {} as FE.FormData,
};

export const clearSessionStorageFormData = () => {
    sessionFormData.modifiedButNotSaved = {};
    sessionStorage.removeItem(SESSION_STORAGE_FORM_KEY);
};

export const updateModifiedData = (data: FE.FormData) => {
    Object.assign(sessionFormData.modifiedButNotSaved, data);
    return sessionFormData.modifiedButNotSaved;
};
